/**
 * Custom hook to save and restore text selection
 */
import { useRef, useEffect } from "react";

export const useSelectionSaver = (textId) => {
  const savedSelectionRef = useRef(null);

  const restoreSelection = () => {
    if (savedSelectionRef.current) {
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(savedSelectionRef.current);
    }
  };

  useEffect(() => {
    if (!textId) return;

    const saveSel = () => {
      const sel = window.getSelection();
      if (sel && sel.rangeCount) {
        const r = sel.getRangeAt(0);
        // only keep ranges inside our editable divs
        const ids = [
          `content-div-${textId}`,
          `note-div-${textId}`,
          `task-div-${textId}`,
        ];
        let n = r.startContainer;
        while (n && n !== document) {
          if (n.nodeType === 1 && ids.includes(n.id)) {
            savedSelectionRef.current = r.cloneRange();
            break;
          }
          n = n.parentNode;
        }
      }
    };
    document.addEventListener("selectionchange", saveSel);
    return () => document.removeEventListener("selectionchange", saveSel);
  }, [textId]);

  return { savedSelectionRef, restoreSelection };
};
